const actionDefault = {
  methods: {
    executeActionDefault() {
      let action = this.actions.find(action => action.default === true);

      if (action) {
        this.execute(action);
      } else {
        return;
      }
    },
  }
}

export default actionDefault;
